import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: max-content;
  padding: 16px;
  border: 1px solid #cecece;
  border-radius: 5px;

  input {
    padding: 5px !important;
  }

  textarea {
    padding: 5px !important;
  }
`;

export const OptionContainer = styled.div`
  display: flex;

  & > * {
    margin-right: 16px !important;
  }
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > textarea {
    width: 100%;
  }

  & > * {
    margin-bottom: 8px !important;
  }
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > * {
    margin-top: 16px !important;
  }
`;
